import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';
import { PRIVACY_POLICY } from '../content/legalContent';

const PrivacyPage = () => (
  <LegalPageLayout document={PRIVACY_POLICY} activePath="/privacy" />
);

export default PrivacyPage;
